export enum FontFamily {
  JetbrainsMono = 'JetBrains Mono, monospace',
}
